// @ts-check

import {
  getOrgConfigForWorkspace as getOrgConfigForWorkspaceQuery,
  updateOrgConfigForWorkspace as updateOrgConfigForWorkspaceMutation,
} from "src/queries/orgConfig.graphql";

import { useOrgConfig } from "./useOrgConfig";

/**
 * Hook for managing org config for workspace.
 * @returns {{
 *  loading: boolean,
 *  config: org_config.workspace.Config,
 *  createdBy: string,
 *  createdAt: import("moment").Moment,
 *  update: (config: org_config.workspace.Config) => Promise<boolean>,
 *  updating: boolean,
 * }}
 */
export const useOrgConfigForWorkspace = () =>
  useOrgConfig({
    getQuery: getOrgConfigForWorkspaceQuery,
    updateMutation: updateOrgConfigForWorkspaceMutation,
  });
